<template>
  <DatatableReportV3
    title="Equipment Capture"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import EquipmentDetailsModal from "@/Equipment/EquipmentDetailsModal.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import store from "@/vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        bLengthChange: false,
        columns: [
          { data: "invoice_date", title: "Invoice Date", searchable: false },
          { data: "invoice_id", title: "Invoice" },
          { data: "job_id", title: "Job" },
          { data: "department", title: "Department" },
          { data: "technician", title: "Opportunity Owner" },
          { data: "customer" },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          { data: "location_name", title: "Location Name" },
          { data: "address" },
          { data: "line_item", title: "Line Item" },
          { data: "request_type", title: "Request Type", searchable: false },
          {
            data: "equipment_type",
            title: "Equipment Type",
            searchable: false
          },
          { data: "equipment" }
        ],
        vueComponents: [
          {
            rootId: "equipment-read-only-vue",
            component: EquipmentDetailsModal,
            options: {
              store
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Equipment Capture" });
  }
};
</script>

<style lang="scss" scoped></style>
